export enum SepaSequenceEnum {
  FIRST = 'FIRST',
  RECURRING = 'RECURRING',
  ONE_TIME = 'ONE_TIME',
}
